import {
  PUBLIC_QUEUE_RAMP_KEY,
  WANDB_ENTITY_NAME,
  WANDB_JOBS_PROJECT_NAME,
  WANDB_PUBLIC_QUEUE_NAME,
} from './constants';

export type OrderNode = {
  path: string | string[];
  nestedPaths?: OrderNode[];
};

export type InputOrderSpec = OrderNode[];

export type PublicJobInfo = {
  entityName: string;
  projectName: string;
  jobName: string;
  leaderboardName: string;
  leaderboardConfigOverrideKey?: string;
  inputOrderSpec: InputOrderSpec;
};

const evalApiHostedModelInputOrderSpec: InputOrderSpec = [
  {
    path: 'model',
    nestedPaths: [
      {path: 'base_url'},
      {path: 'model_name'},
      {path: 'api_key_var'},
    ],
  },
  {
    path: 'tasks',
  },
  {
    path: 'hf_token',
  },
  {
    path: 'scorer_api_key',
  },
  {
    path: 'limit',
  },
  {
    path: 'create_leaderboard',
  },
];

const evalModelCheckpointInputOrderSpec: InputOrderSpec = [
  {
    path: 'artifact_path',
  },
  {
    path: 'tasks',
  },
  {
    path: 'hf_token',
  },
  {
    path: 'scorer_api_key',
  },
  {
    path: 'limit',
  },
  {
    path: 'create_leaderboard',
  },
];

export const PUBLIC_JOBS_INFO: Record<string, PublicJobInfo> = {
  'Evaluate API-hosted model': {
    entityName: WANDB_ENTITY_NAME,
    projectName: WANDB_JOBS_PROJECT_NAME,
    jobName: 'Evaluate API-hosted model',
    leaderboardName: 'Inspect-AI-Leaderboard',
    leaderboardConfigOverrideKey: 'create_leaderboard',
    inputOrderSpec: evalApiHostedModelInputOrderSpec,
  },
  'Evaluate model checkpoint': {
    entityName: WANDB_ENTITY_NAME,
    projectName: WANDB_JOBS_PROJECT_NAME,
    jobName: 'Evaluate model checkpoint',
    leaderboardName: 'Inspect-AI-Leaderboard',
    leaderboardConfigOverrideKey: 'create_leaderboard',
    inputOrderSpec: evalModelCheckpointInputOrderSpec,
  },
};

export const PUBLIC_JOBS = Object.keys(PUBLIC_JOBS_INFO);

export type PublicQueueConfig = {
  queueName: string;
  entityName: string;
  projectName: string;
  validJobs: PublicJobInfo[];

  accessControl: {
    type: 'org-ramp' | 'entity-membership';
    rampKey?: string; // For org-ramp type
    requiredEntity?: string; // For entity-membership type
  };
};

export const PUBLIC_QUEUES: Record<string, PublicQueueConfig> = {
  [WANDB_PUBLIC_QUEUE_NAME]: {
    queueName: WANDB_PUBLIC_QUEUE_NAME,
    entityName: WANDB_ENTITY_NAME,
    projectName: WANDB_JOBS_PROJECT_NAME,
    validJobs: [
      PUBLIC_JOBS_INFO['Evaluate API-hosted model'],
      PUBLIC_JOBS_INFO['Evaluate model checkpoint'],
    ],

    accessControl: {
      type: 'org-ramp',
      rampKey: PUBLIC_QUEUE_RAMP_KEY,
    },
  },
};

export const getPublicQueueConfig = (
  queueName: string
): PublicQueueConfig | undefined => {
  return PUBLIC_QUEUES[queueName];
};
